<template>
  <div>
    <v-container class="">            
      <v-divider />
        <!--
        <v-row class="green accent-2 px-2">  
          <v-col cols="2">
            <p class="subtitle-2">                      
              Nama Kontrak / Pekerjaan
            </p>
          </v-col>                
          <v-col cols="2">
            <p class="subtitle-2">                      
              Lokasi Pekerjaan
            </p>
          </v-col>
          <v-col cols="2">
            <p class="subtitle-2">                      
              Instasi Pemberi Pekerjaan
            </p>
          </v-col>
          <v-col cols="2">
            <p class="subtitle-2">                      
              Nilai Kontrak
            </p>
          </v-col>
          <v-col cols="2">
            <p class="subtitle-2">                      
              Tgl Mulai
            </p>
          </v-col>
          <v-col cols="2">
            <p class="subtitle-2">                      
              Tgl Selesai
            </p>
          </v-col>
        </v-row>
        <v-divider />
        <template v-if="pos3Count == 0">
          <v-row >
            <v-col cols="12" class="text-center">
              <p>TIDAK ADA DATA</p>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <template v-for="item in pos3List">
            <v-row :key="item.id" class="px-2">
              <v-col cols="2">
                <div>{{ item.namaKontrak }}</div>
              </v-col>
              <v-col cols="2">
                <div>{{ item.lokasi }}</div>
              </v-col>
              <v-col cols="2" align-self="start" class="pa-0">
                <v-row>
                  <v-col cols="2">
                    <span>
                      <v-btn icon color="grey" @click.prevent="getLinkDownload(item.dokumen)"> <v-icon>get_app</v-icon> </v-btn>
                    </span>
                  </v-col>
                  <v-col>
                    <div>{{ item.instansi }}</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2">
                <div>{{ item.nilaiKontrak }}</div>
              </v-col>
              <v-col cols="2">
                <div>{{ getDatefnsFormat(item.tglPelaksanaan) }}</div>
              </v-col>
              <v-col cols="2">
                <div>{{ getDatefnsFormat(item.tglSelesaiKontrak) }}</div>
              </v-col>
            </v-row>
            <v-divider :key="'B'+item.id"/>
          </template>
        </template>
      -->

      <v-row>
        <v-col>
          <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="pos3List"
            :items-per-page="10"
            :single-select="true"
            item-key="id"
          >
            <template v-slot:item.instansi_pemberi="{item}">
              <v-btn icon color="grey" @click.prevent="getLinkDownload(item.dokumen)"><v-icon>get_app</v-icon></v-btn>
              {{ item.instansi }}
            </template>
            <template v-slot:item.tglMulai="{item}">
              {{ getDatefnsFormat(item.tglPelaksanaan) }}
            </template>
            <template v-slot:item.tglSelesai="{item}">
              {{ getDatefnsFormat(item.tglSelesaiKontrak) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <template v-if="isVerifikasi">
            <v-chip dark color="green">
              <v-avatar left>
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-avatar>Sudah Verifikasi
            </v-chip>
          </template>
          <template v-else>
            <v-card>
              <v-textarea v-model="remark" label="Remark: Catatan kekurangan kelengkapan data" outlined ></v-textarea>
              <v-card-actions>
                <v-btn color="success" @click="verifikasiClick()">Verifikasi</v-btn>
                <v-btn color="error" @click="dataKurangLengkapClick()">Data Kurang Lengkap</v-btn>
                <v-label v-if="remarkSubmitted"><span class="blue--text">Catatan kekurangan kelengkapan data diperbarui</span></v-label>
              </v-card-actions>
            </v-card>
          </template>
        </v-col>
      </v-row>

    </v-container>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>
  
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      // Table headers
      headers: [
        { text: "Nama Kontrak / Pekerjaan", value: "namaKontrak", class: "green accent-2 subtitle-2" },
        { text: "Lokasi Pekerjaan", value: "lokasi", class: "green accent-2 subtitle-2" },
        { text: "Instansi Pemberi", value: "instansi_pemberi", class: "green accent-2 subtitle-2" },
        { text: "Alamat", value: "alamat", class: "green accent-2 subtitle-2" },
        { text: "Tgl Mulai", value: "tglMulai", class: "green accent-2 subtitle-2" },
        { text: "Tgl Selesai", value: "tglSelesai", class: "green accent-2 subtitle-2" },
      ],
      pos3Count: 0,
      pos3List: [],
      remark: '',
      remarkSubmitted: false,

      submitting: false,
    }
  },
  watch: {
    Id: function(newVal, oldVal) {
      console.log(`oldVal = ${oldVal}, newVal = ${newVal}`)
      this.pos3Count = 0
      this.pos3List = []
      this.getVendorData(newVal)
      this.getRemark('pengalaman');
    }
  },
  computed: {
    isVerifikasi: function() {
      return this.$store.getters['reg/statusPengalaman'] === 'A'
    },
    Id: function() {
      return this.$store.getters['ven/venId']
    }
  },
  mounted: function() {
    this.getVendorData()
    this.getRemark('pengalaman')
  },
  methods: {
    async getRemark(jenis) {
      this.remark = "";
      this.remarkSubmitted = false;
      
      await axios.get(`${apiUrl}/vendor/remark/jenis/${jenis}/id/${this.Id}`)
      .then((response) => {
        console.log(response)
        this.remark = response.data
      })
    },

    verifikasiClick: async function() {
      this.submitting = true;

      await axios.post(apiUrl+'/vendor/perusahaan/status', { jenisStatus: 'pengalaman', vendorId: this.Id, val: 'A'})
      .then((response) => {
        console.log(response)
        this.$store.commit('reg/setStatusPengalaman', 'A')
      })
      .finally( () => {
        this.submitting = false;
      });
    },

    dataKurangLengkapClick: async function() {
      const payload = {
        jenisStatus: "pengalaman",
        value: this.remark
      };

      this.submitting = true;

      await axios.put(apiUrl + "/vendor/perusahaan/remark/" + this.Id, payload)
      .then( (response) => {
        console.log(response);
      })
      .catch( (error) => {
        console.error(error);
      })
      .finally( () => {
        this.submitting = false;
      });

      this.remarkSubmitted = true;
    },
    getVendorData: async function() {
      await axios.get(`${apiUrl}/vendor/pengalaman/${this.$store.getters['ven/venId']}`)
      .then((response) => {
        if (response.data.statusCode != 200) {
          this.pos3List = []
        }
        else {
          response.data.data.forEach(element => {
            this.pos3List.push(element)
          })              
        }
        this.pos3Count = this.pos3List.length
      })
      .catch((error) => {
        console.log(error)
      })  
    },
    getDatefnsFormat: function(date) {
      return format(parseISO(date), "dd MMM yyyy")
    },
    getLinkDownload: function(dok) {
      /*
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
      */
      window.open(`${apiUrl}/${dok}`, '_blank');
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(parseISO(date), "dd MMM yyyy") : ''
    },
  }
}
</script>

<style>

</style>